/**
 * title -> string = titulo
 * primaryColor -> string = cor do titulo
 * subtitle -> string = subtitulo
 * secondaryColor -> string = cor do subtitulo e do divider
 * dividerColor -> string = cor do divider
 */

import React from "react";
import './PageTitle.css'
import Divider from "../Divider/Divider";
import { primary } from '../../theme/colors'

const PageTitle = props => {
    const { title, subtitle, secondaryColor, primaryColor, dividerColor, _customClassName } = props
    return <>
        <div className="page-title-container">
            <span dangerouslySetInnerHTML={{ __html: title }} className='text-title-secondary primary300 page-title' style={{ ...(primaryColor ? { color: primaryColor } : {}) }}></span>
            {subtitle && <span className='text-title-third page-title-sub' style={{ ...(secondaryColor ? { color: secondaryColor } : { color: primary.primary100 }) }}>{subtitle}</span>}
            <Divider width='70px' margin='5px 0' color={dividerColor || ''} _customClassName={_customClassName || ''} />
        </div>


    </>
}

export default PageTitle